// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module__banner___1qGjS","bannerParallax":"Banner-module__bannerParallax___SmFzd","bannerDramatic":"Banner-module__bannerDramatic___arI-N"};